/**
 * @generated SignedSource<<f744d3ed6722b7540aa3578abc2c65eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PublishState = "ARCHIVED" | "DELETED" | "DRAFT" | "PUBLISHED" | "%future added value";
export type DeleteNodeOption_deleteEvent_Mutation$variables = {
  eventId: string;
};
export type DeleteNodeOption_deleteEvent_Mutation$data = {
  readonly deleteEvent: {
    readonly eventDeleted: {
      readonly publishState: PublishState;
    };
  } | null;
};
export type DeleteNodeOption_deleteEvent_Mutation = {
  response: DeleteNodeOption_deleteEvent_Mutation$data;
  variables: DeleteNodeOption_deleteEvent_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "eventId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishState",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteNodeOption_deleteEvent_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEventsDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "deleteEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "eventDeleted",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteNodeOption_deleteEvent_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEventsDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "deleteEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "eventDeleted",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "306978b22e705dbe78253693056c58a0",
    "id": null,
    "metadata": {},
    "name": "DeleteNodeOption_deleteEvent_Mutation",
    "operationKind": "mutation",
    "text": "mutation DeleteNodeOption_deleteEvent_Mutation(\n  $eventId: ID!\n) {\n  deleteEvent(input: {id: $eventId}) {\n    eventDeleted {\n      publishState\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "95d7d56625d5e9a2d23ccd1ad1ad2284";

export default node;
